const TDC_DP_data = {
	TDC_DP_enable: false,
	TDC_DP_cart_drawer_enable: false,
	TDC_DP_base_discount_code: "MDW20",
	TDC_DP_base_discount_code_off: 20,
	TDC_DP_threshold_for_tiered_discount: 12000,
	TDC_DP_tiered_discount_code: "MDW25",
	TDC_DP_tiered_discount_code_off: 25,
	TDC_DP_sale_price_background_color: "#e96854",
	TDC_DP_sale_price_font_color: "#ffffff",
	TDC_DP_code_background_color: "#e96854",
	TDC_DP_code_font_color: "#ffffff",
	TDC_DP_member_discount_when_code_applied: 5,
	TDC_DP_membership_price: 1900,
	TDC_DP_witch_code_text_for_collection: "with code",
	TDC_DP_witch_code_text_for_product: "with code"
}


const SDC_DP_data = {
	SDC_DP_enable: false,
	SDC_DP_base_discount_code: "",
	SDC_DP_base_discount_code_off: 25,
	SDC_DP_sale_price_background_color: "",
	SDC_DP_sale_price_font_color: "",
	SDC_DP_code_background_color: "",
	SDC_DP_code_font_color: "",
	SDC_DP_member_discount_when_code_applied: 5,
	SDC_DP_membership_price: 1900,
	SDC_DP_witch_code_text_for_collection: "with code",
	SDC_DP_witch_code_text_for_product: "with code"
}


let isRenderPage = false
let cartTotal = 0


document.addEventListener('DOMContentLoaded', () => {
	if (!TDC_DP_data.TDC_DP_enable && !SDC_DP_data.SDC_DP_enable) return

	const url = window.location.href
	const isCollections = url.includes('collections')
	const isProducts = url.includes('products')
	const isOtherPage = !isCollections && !isProducts
	const isCarDrawerEl = document.querySelector('#cart-drawer')

	document.addEventListener('updateCart', function(event) {
		const cartDrawerThresholdBarEl = document.querySelector('#c-cartDrawerThresholdBar')
		cartTotal = cartDrawerThresholdBarEl ? Number(cartDrawerThresholdBarEl.getAttribute('data-cart-total')) : 0

		if (TDC_DP_data.TDC_DP_cart_drawer_enable && isCarDrawerEl) handleTieredDiscountForCartDrawerSubtotalEl(event.detail.cartData)

	  if (isCollections) {
		  setTimeout(() => {
		    handleTieredDiscountForCollectionsAndOtherPage()
		  }, 2000) // waiting for Searchspring download
	  }

	  if (isProducts) handleTieredDiscountForProduct()
	  if (isOtherPage) handleTieredDiscountForCollectionsAndOtherPage(false, true)
	})

	window.FctApp.cart.refreshCart()


	if (isCollections) {
		// Searchspring tracking dynamic loading of items
		setTimeout(() => {
			const content = document.querySelector('#product-grid .product-grid')

			const observer = new MutationObserver(function (mutationsList) {
				for (const mutation of mutationsList) {
					if (mutation.type === 'childList') handleTieredDiscountForCollectionsAndOtherPage(true)
				}
			})

			const config = {childList: true}

			observer.observe(content, config)
		}, 2000)
	}
})


function handleTieredDiscountForCartDrawerSubtotalEl(cartData = {}) {
	const isCarDrawerSubtotalEl = document.querySelector('#cart-drawer .ajax-checkout .estimate')

	if (!isCarDrawerSubtotalEl) return

	const itemsSubtotalPrice = cartData.original_total_price
	const items = cartData.items

	const membershipProduct = items.find(i => i.product_type?.toLowerCase() === 'membership')
	const discountCodeIsApplied = items.some(i => i.discounts.some(d => d.title === TDC_DP_data.TDC_DP_tiered_discount_code || d.title === TDC_DP_data.TDC_DP_base_discount_code))
	const membershipProductPrice = membershipProduct ? membershipProduct.final_price * membershipProduct.quantity : 0

	const price = itemsSubtotalPrice - membershipProductPrice

	if (isCarDrawerSubtotalEl && price > 0 && !discountCodeIsApplied) {
		const checkoutTieredDiscountEl = document.querySelector('#checkout-tiered-discount')
	  if (checkoutTieredDiscountEl) checkoutTieredDiscountEl.innerHTML = renderPriceWithCodeForCardDrawerSubtotal(price, !!membershipProduct)
	}
}

function handleTieredDiscountForCollectionsAndOtherPage(resetIsRenderPage = false, isOtherPage = false) {
	const initQuery = SDC_DP_data.SDC_DP_enable
			? `${isOtherPage ? '.use-tired-discount ' : '#product-grid .product-grid ' }.grid.is-single-discount:not(.exclude-tiered-discount)`
			: `${isOtherPage ? '.use-tired-discount ' : '#product-grid .product-grid ' }.grid:not(.exclude-tiered-discount)`

	const productGridItems = document.querySelectorAll(initQuery)

	if (resetIsRenderPage) isRenderPage = false

	if (!isRenderPage) {

	  productGridItems.forEach((e) => {
		  const productDescr = e.querySelector('.product-descr:not(.tiered-discount)')

		  if (!productDescr) return

		  productDescr.classList.add('tiered-discount')

			// crutch: delete after abandoning the Searchspring!!!
			const {
				isCrutchMemberPacks = false,
				crutchRegularPrice = 0
			} = isOtherPage
				? {}
				: crutchForMemberProductWitchSearchspring(productDescr)

			const isMemberPacks = !!productDescr.getAttribute('data-metafield-prod-id') || isCrutchMemberPacks


		  const price = productDescr.querySelector('.money')
		  const salePrice = productDescr.querySelector('.sale')

		  const str = salePrice ? salePrice?.innerText : price?.innerText
		  const num = parseFloat(str?.replace('$', '')) * 100

			const regularPrice = productDescr.querySelector('.pro-price')?.getAttribute('data-regular-price') || crutchRegularPrice

			productDescr.insertAdjacentHTML('beforeend', renderPriceWithCodeForCollection(regularPrice ? regularPrice : num, isMemberPacks))
	  })

	  isRenderPage = true

	} else {

	  const productDescrItems = document.querySelectorAll('.product-descr.tiered-discount')

	  productDescrItems.forEach(e => {

			// crutch: delete after abandoning the Searchspring!!!
			const {
				isCrutchMemberPacks = false,
				crutchRegularPrice = 0
			} = isOtherPage
				? {}
				: crutchForMemberProductWitchSearchspring(e)

			const isMemberPacks = !!e.getAttribute('data-metafield-prod-id') || isCrutchMemberPacks
			const price = e.querySelector('.money')
		  const salePrice = e.querySelector('.sale')

		  const str = salePrice ? salePrice?.innerText : price?.innerText
		  const num = parseFloat(str?.replace('$', '')) * 100

			const regularPrice = e.querySelector('.pro-price')?.getAttribute('data-regular-price') || crutchRegularPrice

			const { finalPrice, discountCode } = getFinalPriceAndDiscountCode(regularPrice ? regularPrice : num, isMemberPacks)

			const finalPriceEl = e.querySelector('.final-price')
			finalPriceEl.textContent = `$${finalPrice.toFixed(2)}`

			const discountCodeEl = e.querySelector('.discount-code')
			discountCodeEl.textContent = discountCode
	  })
	}

}

function handleTieredDiscountForProduct(resetIsRenderPage) {
	const initQuery = SDC_DP_data.SDC_DP_enable
		? '#price-preview.is-single-discount:not(.exclude-tiered-discount)'
		: '#price-preview:not(.exclude-tiered-discount)'

	const pricePreviewEls = document.querySelectorAll(initQuery)

	if (!pricePreviewEls.length) return

	if (resetIsRenderPage) isRenderPage = false

	let price = pricePreviewEls[0].getAttribute('data-regular-price')
	let isMemberPacks = !!pricePreviewEls[0].getAttribute('data-metafield-prod-id')

	if (!isRenderPage) {
	  pricePreviewEls.forEach(pricePreviewEl => pricePreviewEl.classList.add('tiered-discount'))

	  const priceTieredDiscountTargetEls = document.querySelectorAll('.price-tiered-discount-target')

	  if (priceTieredDiscountTargetEls.length) {

		  priceTieredDiscountTargetEls.forEach(e => {
			  e.insertAdjacentHTML('afterend', renderPriceWithCodeForProduct(price, isMemberPacks))
		  })
	  }

	  isRenderPage = true
	} else {
	  const finalPriceEls = document.querySelectorAll('.final-price')
	  const discountCodeEls = document.querySelectorAll('.discount-code')

	  const { finalPrice, discountCode } = getFinalPriceAndDiscountCode(price, isMemberPacks)

	  finalPriceEls.forEach(finalPriceEl => {
			finalPriceEl.textContent = `$${finalPrice.toFixed(2)}`
	  })

	  discountCodeEls.forEach(discountCodeEl => {
			discountCodeEl.textContent = discountCode
	  })
	}
}


// init style
const sale_price_font_color = SDC_DP_data.SDC_DP_enable ? SDC_DP_data.SDC_DP_sale_price_font_color : TDC_DP_data.TDC_DP_sale_price_font_color
const sale_price_background_color = SDC_DP_data.SDC_DP_enable ? SDC_DP_data.SDC_DP_sale_price_background_color : TDC_DP_data.TDC_DP_sale_price_background_color
const witch_code_text_for_product = SDC_DP_data.SDC_DP_enable ? SDC_DP_data.SDC_DP_witch_code_text_for_product : TDC_DP_data.TDC_DP_witch_code_text_for_product
const witch_code_text_for_collection = SDC_DP_data.SDC_DP_enable ? SDC_DP_data.SDC_DP_witch_code_text_for_collection : TDC_DP_data.TDC_DP_witch_code_text_for_collection
const code_background_color = SDC_DP_data.SDC_DP_enable ? SDC_DP_data.SDC_DP_code_background_color : TDC_DP_data.TDC_DP_code_background_color
const code_font_color  = SDC_DP_data.SDC_DP_enable ? SDC_DP_data.SDC_DP_code_font_color : TDC_DP_data.TDC_DP_code_font_color


function renderPriceWithCodeForProduct(price, isMemberPacks) {
	const { finalPrice, discountCode } = getFinalPriceAndDiscountCode(price, isMemberPacks)

	return `
						<div class="with-code" style="color: #000; display: flex; font-size: 18px; margin-top: 5px">
							<div style="color: ${sale_price_font_color}; background-color: ${sale_price_background_color}; padding: 2px 5px; margin-right: 5px; border-radius: 5px;" class="final-price">$${finalPrice.toFixed(2)}</div>
								${witch_code_text_for_product}
								<span
									class="discount-code"
									style="
											margin-left: 5px;
											padding: 2px 5px;
											border-radius: 5px;
											background-color: ${code_background_color};
											color: ${code_font_color};
										"
								>${discountCode}</span>
						</div
	`
}

function renderPriceWithCodeForCardDrawerSubtotal(price, isMemberPacks) {
	const { finalPrice, discountCode } = getFinalPriceAndDiscountCode(price, isMemberPacks, true)

	return `
		<div class="with-code" style="display: flex; align-items: center">
		  <div style="color: ${sale_price_font_color}; background-color: ${sale_price_background_color}; padding: 2px 5px; margin-right: 5px; border-radius: 5px;" class="cart-drawer-final-price">$${finalPrice.toFixed(2)}</div>
			<div style="display: flex; align-items: center;">
					<span style="
						display: flex;
					  max-width: 26px;
					  font-size: 10px;
					  line-height: normal;
					">${witch_code_text_for_collection}</span>
					<span
						class="discount-code"
						style="
							padding: 2px 5px;
							border-radius: 5px;
							background-color: ${code_background_color};
							color: ${code_font_color};
						"
					>${discountCode}</span>
				</div>
		</div
	`
}


function renderPriceWithCodeForCollection(price, isMemberPacks) {
	const { finalPrice, discountCode } = getFinalPriceAndDiscountCode(price, isMemberPacks)

	return `
		<div class="with-code" style="display: flex; align-items: center">
		  <div style="color: ${sale_price_font_color}; background-color: ${sale_price_background_color}; padding: 2px 5px; margin-right: 5px; border-radius: 5px;" class="final-price">$${finalPrice.toFixed(2)}</div>
			<div style="display: flex; align-items: center;">
					<span style="
						display: flex;
					  max-width: 26px;
					  font-size: 10px;
					  line-height: normal;
					">${witch_code_text_for_collection}</span>
					<span
						class="discount-code"
						style="
							padding: 2px 5px;
							border-radius: 5px;
							background-color: ${code_background_color};
							color: ${code_font_color};
						"
					>${discountCode}</span>
				</div>
		</div
	`
}


function getFinalPriceAndDiscountCode(price, isMemberPacks = false, isCartDrawer = false) {
	const shopifyPrice = Number(price)
	const isTiered = (isCartDrawer ? shopifyPrice : shopifyPrice + cartTotal) >= TDC_DP_data.TDC_DP_threshold_for_tiered_discount

	const tieredDiscount = SDC_DP_data.SDC_DP_enable
			? SDC_DP_data.SDC_DP_base_discount_code_off / 100
		  : (isTiered ? TDC_DP_data.TDC_DP_tiered_discount_code_off / 100 : TDC_DP_data.TDC_DP_base_discount_code_off / 100)
	const memberDiscount = SDC_DP_data.SDC_DP_enable ? SDC_DP_data.SDC_DP_member_discount_when_code_applied / 100 : TDC_DP_data.TDC_DP_member_discount_when_code_applied / 100
	const membershipPrice = SDC_DP_data.SDC_DP_enable ? SDC_DP_data.SDC_DP_membership_price : TDC_DP_data.TDC_DP_membership_price

	const finalPriceCalculate = () => {
	  return isMemberPacks ? (shopifyPrice * (1 - tieredDiscount)) * (1 - memberDiscount) + membershipPrice : shopifyPrice * (1 - tieredDiscount)
	}

	const finalPrice = finalPriceCalculate() / 100
	const discountCode = SDC_DP_data.SDC_DP_enable
			? SDC_DP_data.SDC_DP_base_discount_code
			: (isTiered ? TDC_DP_data.TDC_DP_tiered_discount_code : TDC_DP_data.TDC_DP_base_discount_code)

	return { finalPrice, discountCode }
}

// crutch: delete after abandoning the Searchspring!!!
function crutchForMemberProductWitchSearchspring(productDescr) {
	const pEl = productDescr?.querySelector('p')
	const pTextContent = pEl?.textContent?.toLowerCase()
	const isCrutchMemberPacks = pTextContent?.includes('member')

	const proPriceEl = productDescr?.querySelector('.pro-price')
	const proPriceId = proPriceEl?.id?.replace(/[^0-9]/g,"")

	const product = meta?.products?.find(e => e?.id === Number(proPriceId))
	const crutchRegularPrice = product?.variants[0]?.price

	return {
	  isCrutchMemberPacks,
	  crutchRegularPrice
	}
}